// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"320":"126e88f5","724":"13fd0cae"}[chunkId] + ".chunk.js");